import axios from "axios";
import store from "@/store"; // Vuex 스토어 임포트
import { BASE_API_URL } from "@/api/config";
import router from "@/routes/routes";

/* axios 인스턴스 생성 */
const service = axios.create({
  baseURL: BASE_API_URL,
});

/* 요청 인터셉터 설정 */
service.interceptors.request.use(
  (config) => {
    const token = store.state.auth.token;
    const tokenType = store.state.auth.tokenType || "Bearer";

    if (token) {
      config.headers.Authorization = `${tokenType} ${token}`;
    }

    return config;
  },
  (error) => {
    store.dispatch("auth/logout");
    router.push({ name: "Login" });
    return Promise.reject(error);
  }
);

/* 응답 인터셉터 설정 */
service.interceptors.response.use(
  (response) => response,
  async (error) => {
    // 401 에러 발생 시 재로그인
    if (error.response && error.response.status === 401) {
      await store.dispatch("auth/logout");
      router.push({ name: "Login" });
    }

    if (error.response && error.response.status === 403) {
      alert("접근할 수 없는 페이지입니다.")
      router.push({ name: "dashboard" });
    }

    return Promise.reject(error);
  }
);

/* HTTP 메소드 인터페이스 */
export default {
  async get(requestUrl, config) {
    try {
      const response = await service.get(requestUrl, config);
      return response;
    } catch (e) {
      return printError(e);
    }
  },

  async post(requestUrl, data, config) {
    try {
      const response = await service.post(requestUrl, data, config);
      return response;
    } catch (e) {
      return printError(e);
    }
  },

  async put(requestUrl, data, config) {
    try {
      const response = await service.put(requestUrl, data, config);
      return response;
    } catch (e) {
      return printError(e);
    }
  },

  async patch(requestUrl, data, config) {
    try {
      const response = await service.patch(requestUrl, data, config);
      return response;
    } catch (e) {
      return printError(e);
    }
  },

  async delete(requestUrl, config) {
    try {
      const response = await service.delete(requestUrl, config);
      return response;
    } catch (e) {
      return printError(e);
    }
  },
};

function printError(error) {
  // eslint-disable-next-line
  console.error("API 호출 중 에러:", error);

  if (error.response) {
    // eslint-disable-next-line
    console.error(
      `[${error.response.status}] ${error.response.data.message || "에러 발생"}`
    );
  } else if (error.request) {
    // eslint-disable-next-line
    console.error("서버로부터 응답을 받을 수 없습니다.");
  } else {
    // eslint-disable-next-line
    console.error(`요청 구성 중 에러가 발생했습니다: ${error.message}`);
  }
  return Promise.reject(error); // 에러를 호출한 쪽으로 전달
}
